export default "__VITE_ASSET__84sJccTQ__"